import { useEffect, useState } from "react";

export const useCombinedState = (externalState) => {
  const [state, setState] = useState(externalState);

  useEffect(() => {
    setState(externalState);
  }, [externalState]);

  return { state, setState };
};
